import React, { useState } from "react";
import AdGroups from "./AdGroups";
import ScreenTags from "./ScreenTags";
import PlaylistTags from "./PlaylistTags";
import Regions from "./Regions";
import Cities from "./Cities";
import TemplateCategories from "./TemplateCategories";
import Restaurants from "./Restaurants";

const TABS = [
  { label: "Creative Ad Group", value: "adgroup", component: <AdGroups /> },
  { label: "Screen Tag", value: "screentag", component: <ScreenTags /> },
  { label: "Playlist Tag", value: "playlisttag", component: <PlaylistTags /> },
  { label: "City", value: "city", component: <Cities /> },
  { label: "Region", value: "region", component: <Regions /> },
  { label: "Restaurant", value: "restaurant", component: <Restaurants /> },
  {
    label: "Template Category",
    value: "templatecategory",
    component: <TemplateCategories />,
  },
];

const AccountManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState(TABS[0]);

  return (
    <div className="flex-1 m-4 p-2">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">
        Account Management
      </h1>
      <div className="flex mb-2 border-b-2 border-primary-default ">
        {TABS.map((tab) => (
          <button
            key={tab.value}
            className={`px-6 py-2 rounded-t-lg font-medium transition-colors duration-150 ${
              activeTab.value === tab.value
                ? "text-white bg-primary-default"
                : "text-gray-600 bg-gray-100 hover:bg-gray-200"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{activeTab.component}</div>
    </div>
  );
};

export default AccountManagement;
